<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <div v-for="rowsData in rows">
            <div class="card-header">
                <StatisticTable
                        :footColumns="rowsData.foot"
                        :headColumns="headColumns"
                        :rows="rowsData.rows"
                        :title="`${Helper.getOfferTitle(offers, rowsData.offer)} (${rowsData.offer})`"
                >
                </StatisticTable>
            </div>
        </div>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import Storage from '../../../api/Storage'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import API from '../../../api/API'
  import {map, orderBy, findIndex} from 'lodash'
  import StatisticTable from '../../../components/StatisticTable.vue'
  import AlphabetScroll from '../../../components/AlbhabetScroll.vue'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: 'Grid',
    components: {
      Filters,
      AlphabetScroll,
      StatisticTable
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          byWmFilterAll: true
        },
        scrollPos: 0,
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        headColumns: [
          {label: this.$root.$t('statistic.webmaster'), field: 'webmaster', width: '120px'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.processed'), field: 'processed'},
          {label: this.$root.$t('statistic.accepted'), field: 'accepted'},
          {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
          {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
          {label: this.$root.$t('statistic.approve'), field: 'approve', width: '50px'},
          {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'}
        ],
        rows: [],
        footColumns: [],
        offers: [],
        web: null
      }
    },
    mounted () {
      this.calculateRows()
      this.getWeb()
      this.getOffers()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
        this.getWeb()
        this.getOffers()
      })
    },
    methods: {
      calculateRows () {
        this.loading = true
        this.offers = Storage.offers.slice(0)
        this.rows = []
        this.footColumns = []
        API.getGrid().then(response => {
          map(response.body, d => {
            this.rows.push({
              offer: d.offer_id,
              rows: [{
                webmaster: {
                  value: Helper.getWebLogin(this.web, d.wm_id)
                },
                total: {
                  value: d.total
                },
                processed: {
                  value: d.processed,
                  bg: true
                },
                accepted: {
                  value: d.approved,
                  bg: true
                },
                canceled: {
                  value: d.canceled,
                  bgg: Helper.renderGistPart(d.total, d.canceled),
                  isCollspaned: true
                },
                canceledPercents: {
                  value: Helper.percents(d.total, d.canceled),
                  bgg: Helper.renderGistPart(d.total, d.canceled, true)
                },
                error: {
                  value: d.error,
                  bgg: Helper.renderGistPart(d.total, d.error),
                  isCollspaned: true
                },
                errorPercents: {
                  value: Helper.percents(d.total, d.error),
                  bgg: Helper.renderGistPart(d.total, d.error, true)
                },
                return: {
                  value: d.return,
                  bgg: Helper.renderGistPart(d.approved, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: Helper.percents(d.approved, d.return),
                  bgg: Helper.renderGistPart(d.approved, d.return, true)
                },
                paid: {
                  value: d.paid,
                  bgg: Helper.renderGistPart(d.approved, d.paid),
                  isCollspaned: true
                },
                paidPercents: {
                  value: Helper.percents(d.approved, d.paid),
                  bgg: Helper.renderGistPart(d.approved, d.paid, true)
                },
                averageBill: {
                  value: '$ ' + d.average_bill_usd.toFixed(2),
                    // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true)),
                  isCollspaned: true
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 ? `${d.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                    // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true), true)
                },
                approve: {
                  value: Helper.percents(d.total, d.approved),
                  bgg: Helper.renderSingleGist(d.total, d.approved)
                },
                approvedFromValid: {
                  value: `${(d.approved_from_valid).toFixed(1)}%`
                }
              }],
              foot: sum(d)
            })
          })

          function sum (data) {
            let sumTotal = 0
            let sumProcessed = 0
            let countProcessed = 0
            let sumAccepted = 0
            let countAccepted = 0
            let sumCanceled = 0
            let countCanceled = 0
            let sumError = 0
            let countError = 0
            let sumReturn = 0
            let countReturn = 0
            let sumPaid = 0
            let countPaid = 0
            let sumAverageBillLocal = 0.0
            let sumAverageBill = 0.0
            sumTotal += data.total
            if (data.processed > 0) {
              sumProcessed += data.processed
              countProcessed++
            }
            if (data.approved > 0) {
              sumAccepted += data.approved
              countAccepted++
              sumAverageBillLocal += parseFloat(data.average_bill_local) * data.approved
              sumAverageBill += parseFloat(data.average_bill_usd) * data.approved
            }
            if (data.canceled > 0) {
              sumCanceled += data.canceled
              countCanceled++
            }
            if (data.error > 0) {
              sumError += data.error
              countError++
            }
            if (data.return > 0) {
              sumReturn += data.return
              countReturn++
            }
            if (data.paid > 0) {
              sumPaid += data.paid
              countPaid++
            }
            let array = {
              label: {
                value: 'Итого'
              },
              total: {
                value: `${sumTotal}`,
                graph: true
              },
              processed: {
                value: `${sumProcessed}`,
                graph: true
              },
              accepted: {
                value: `${sumAccepted}`,
                graph: true
              },
              canceled: {
                value: `${sumCanceled}`,
                graph: true
              },
              canceledPercents: {
                value: Helper.percents(sumTotal, sumCanceled),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              error: {
                value: `${sumError}`,
                graph: true
              },
              errorPercents: {
                value: Helper.percents(sumTotal, sumError),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              return: {
                value: `${sumReturn}`,
                graph: true
              },
              returnPercents: {
                value: Helper.percents(sumAccepted, sumReturn),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              paid: {
                value: `${sumPaid}`,
                graph: true
              },
              paidPercents: {
                value: Helper.percents(sumAccepted, sumPaid),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              averageBill: {
                value: Helper.averageBillDayCount(sumAverageBill, sumAccepted),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '$'
                }
              },
              averageBillLocal: {
                value: Helper.newLocalAverageBill(sumAverageBillLocal, sumAccepted, getSymbolFromCurrency(data.local_currency)),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: Storage.selectedCountry.currency_symbol
                }
              },
              approve: {
                value: Helper.percents(sumTotal, sumAccepted),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '%'
                }
              },
              approvedFromValid: {
                value: Helper.approvedFromValid(sumAccepted, sumTotal, sumError)
              }
            }
            return array
          }
        })
      },
      getWeb () {
        this.web = null
        API.getWebmastersAll(Helper.getCountryList()).then(res => {
          this.web = res.body
        })
          .catch(error => {
            console.log(error)
          })
      },
      getOffers () {
        API.getOffers(Helper.getCountryList())
          .then(res => {
            Storage.offers = res.body
          })
          .catch(error => {
            console.log(error)
          })
      }
    }

  }
</script>

<style scoped>
    .card-header {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// Grid.vue?a496b1e6